// HeaderUserSection.js
// 从 App.js 抽取出的「头部右侧用户区域」组件
// 包含：已登录时的头像+昵称+个人中心+登出；未登录时的登录/注册按钮
// 学单词/学用法页面原本已经有头像展示，这次统一同步给学句子页面（之前学句子页缺少头像）

import React from 'react';

function HeaderUserSection({
  isMobile,
  theme,
  user,
  userProfile,
  setCurrentPage,
  handleLogout,
  setLoginTab,
  setShowLoginModal,
  setAuthError,
}) {
  const userSectionStyle = {
    width: isMobile ? '100%' : '25%',
    textAlign: isMobile ? 'center' : 'right',
    flexShrink: 0,
    display: 'flex',
    flexDirection: 'column',
    alignItems: isMobile ? 'center' : 'flex-end',
  };

  return (
    <div style={userSectionStyle}>
      {user ? (
        <div style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: isMobile ? 'center' : 'flex-end',
          flexWrap: isMobile ? 'wrap' : 'nowrap',
          gap: '12px',
          paddingTop: '4px',
        }}>
          <img
            src={userProfile?.photoURL || `https://ui-avatars.com/api/?name=${encodeURIComponent(userProfile?.displayName || user.email.charAt(0))}&size=40&background=1890ff&color=fff`}
            alt="头像"
            style={{
              width: '36px',
              height: '36px',
              borderRadius: '50%',
              objectFit: 'cover',
              border: '2px solid #fff',
              boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
              flexShrink: 0,
            }}
          />
          <span style={{ fontSize: '0.95em', color: theme === 'dark' ? '#e0e0e0' : '#333', flexShrink: 0 }}>
            {userProfile?.displayName || '未设置昵称'}
          </span>
          <button
            onClick={() => setCurrentPage('personal')}
            style={{
              padding: '4px 10px',
              border: 'none',
              background: 'none',
              color: '#1890ff',
              cursor: 'pointer',
              fontSize: '0.95em',
              flexShrink: 0,
              whiteSpace: 'nowrap',
            }}
          >
            个人中心
          </button>
          <button
            onClick={handleLogout}
            style={{
              padding: '4px 10px',
              border: 'none',
              background: 'none',
              color: theme === 'dark' ? '#cccccc' : '#666',
              cursor: 'pointer',
              fontSize: '0.95em',
              flexShrink: 0,
              whiteSpace: 'nowrap',
            }}
          >
            登出
          </button>
        </div>
      ) : (
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: isMobile ? 'center' : 'flex-end',
          paddingTop: '4px',
          gap: '8px',
        }}>
          <button
            onClick={() => { setLoginTab('login'); setShowLoginModal(true); setAuthError(null); }}
            style={{
              padding: '7px 18px',
              background: '#1890ff',
              color: 'white',
              border: 'none',
              borderRadius: '6px',
              cursor: 'pointer',
              fontSize: '0.95em',
              fontWeight: '600',
              whiteSpace: 'nowrap',
            }}
          >
            登录
          </button>
          <button
            onClick={() => { setLoginTab('register'); setShowLoginModal(true); setAuthError(null); }}
            style={{
              padding: '7px 18px',
              background: 'none',
              color: '#1890ff',
              border: '1px solid #1890ff',
              borderRadius: '6px',
              cursor: 'pointer',
              fontSize: '0.95em',
              fontWeight: '600',
              whiteSpace: 'nowrap',
            }}
          >
            注册
          </button>
        </div>
      )}
    </div>
  );
}

export default HeaderUserSection;
